import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";


import "../Styles/Resetpassword.css";
import { reset_password } from "../api/serverWrapper";

const Resetpassword = ({
  visible,
  onClose,
  userId,
}) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] =
    useState("");

  const [showOldPassword, setShowOldPassword] =
    useState(false);

  const [showNewPassword, setShowNewPassword] =
    useState(false);

  const [showConfirmPassword, setShowConfirmPassword] =
    useState(false);

  const [errors, setErrors] = useState({});
  const [resetLoading, setResetLoading] =
    useState(false);

  const clearFields = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");

    setShowOldPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);

    setErrors({});
  };

  const handleConfirm = async () => {
    if (resetLoading) return;

    const newErrors = {};

    if (!oldPassword.trim()) {
      newErrors.oldPassword =
        "Current password is required";
    }

    if (!newPassword.trim()) {
      newErrors.newPassword =
        "New password is required";
    } else if (newPassword.length < 6) {
      newErrors.newPassword =
        "Password must be at least 6 characters";
    }

    if (
      oldPassword.trim() &&
      newPassword.trim() &&
      oldPassword === newPassword
    ) {
      newErrors.newPassword =
        "New password cannot be the same as current password";
    }

    if (!confirmPassword.trim()) {
      newErrors.confirmPassword =
        "Please confirm your new password";
    } else if (
      newPassword.trim() &&
      newPassword !== confirmPassword
    ) {
      newErrors.confirmPassword =
        "Passwords do not match";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setResetLoading(true);

    try {
      const res = await reset_password({
        UserId: userId,
        OldPassword: oldPassword,
        NewPassword: newPassword,
      });

      console.log("RESET PASSWORD RESPONSE:", res);

      if (res.success) {
        alert(
          res.message || "Password changed successfully"
        );

        clearFields();
        onClose?.();
      } else {
        alert(
          res.message || "Failed to change password"
        );
      }
    } catch (error) {
      console.log(
        "RESET PASSWORD ERROR:",
        error
      );

      alert(
        "Something went wrong while changing password"
      );
    } finally {
      setResetLoading(false);
    }
  };

  const handleCancel = () => {
    if (resetLoading) return;

    clearFields();
    onClose?.();
  };

  if (!visible) return null;

  return (
    <div
      className="reset-password-overlay"
      onClick={handleCancel}
    >
      <div
        className="reset-password-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title */}
        <h2 className="reset-password-title">
          Change Password
        </h2>

        <div className="reset-password-title-line" />

        {/* Current Password */}
        <div className="reset-input-group">
          <label className="reset-input-label">
            Current Password
          </label>

          <div className="reset-input-wrapper">
            <input
              type={
                showOldPassword
                  ? "text"
                  : "password"
              }
              value={oldPassword}
              onChange={(e) => {
                setOldPassword(e.target.value);

                setErrors((prev) => ({
                  ...prev,
                  oldPassword: "",
                }));
              }}
              placeholder="Enter current password"
              disabled={resetLoading}
              className="reset-input"
            />

            <button
              type="button"
              className="password-toggle"
              disabled={resetLoading}
              onClick={() =>
                setShowOldPassword(
                  !showOldPassword
                )
              }
            >
              {showOldPassword ? (
                <FaEye />
              ) : (
                <FaEyeSlash />
              )}
            </button>
          </div>

          {errors.oldPassword && (
            <span className="reset-error">
              {errors.oldPassword}
            </span>
          )}
        </div>

        {/* New Password */}
        <div className="reset-input-group">
          <label className="reset-input-label">
            New Password
          </label>

          <div className="reset-input-wrapper">
            <input
              type={
                showNewPassword
                  ? "text"
                  : "password"
              }
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);

                setErrors((prev) => ({
                  ...prev,
                  newPassword: "",
                }));
              }}
              placeholder="Enter new password"
              disabled={resetLoading}
              className="reset-input"
            />

            <button
              type="button"
              className="password-toggle"
              disabled={resetLoading}
              onClick={() =>
                setShowNewPassword(
                  !showNewPassword
                )
              }
            >
              {showNewPassword ? (
                <FaEye />
              ) : (
                <FaEyeSlash />
              )}
            </button>
          </div>

          {errors.newPassword && (
            <span className="reset-error">
              {errors.newPassword}
            </span>
          )}
        </div>

        {/* Confirm Password */}
        <div className="reset-input-group">
          <label className="reset-input-label">
            Confirm New Password
          </label>

          <div className="reset-input-wrapper">
            <input
              type={
                showConfirmPassword
                  ? "text"
                  : "password"
              }
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);

                setErrors((prev) => ({
                  ...prev,
                  confirmPassword: "",
                }));
              }}
              placeholder="Confirm your new password"
              disabled={resetLoading}
              className="reset-input"
            />

            <button
              type="button"
              className="password-toggle"
              disabled={resetLoading}
              onClick={() =>
                setShowConfirmPassword(
                  !showConfirmPassword
                )
              }
            >
              {showConfirmPassword ? (
                <FaEye />
              ) : (
                <FaEyeSlash />
              )}
            </button>
          </div>

          {errors.confirmPassword && (
            <span className="reset-error">
              {errors.confirmPassword}
            </span>
          )}
        </div>

        {/* Buttons */}
        <div className="reset-button-container">
          <button
            type="button"
            className="reset-cancel-button"
            onClick={handleCancel}
            disabled={resetLoading}
          >
            Cancel
          </button>

          <button
            type="button"
            className="reset-confirm-button"
            onClick={handleConfirm}
            disabled={resetLoading}
          >
            {resetLoading ? (
              <span className="reset-loading-content">
                <span className="reset-spinner" />
                Changing...
              </span>
            ) : (
              "Confirm"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Resetpassword;